import { Minus, Plus } from "lucide-react";
import { cn } from "@/lib/utils";

export function QtyStepper({ value, onChange, min = 0, testId }) {
  return (
    <div className="inline-flex items-center gap-2" data-testid={testId}>
      <button
        type="button"
        data-testid={testId ? `${testId}-minus` : undefined}
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        className={cn(
          "flex h-9 w-9 items-center justify-center rounded-full border border-border bg-card transition active:scale-95 disabled:opacity-40",
        )}
      >
        <Minus className="h-4 w-4" />
      </button>
      <span className="w-6 text-center text-base font-semibold tabular-nums">{value}</span>
      <button
        type="button"
        data-testid={testId ? `${testId}-plus` : undefined}
        onClick={() => onChange(value + 1)}
        className="flex h-9 w-9 items-center justify-center rounded-full bg-primary text-primary-foreground transition active:scale-95"
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
}
